import { RWLocalStorage } from "rw-web-local-storage";

const appPrefix = "tiolem-bgolan-cms";

const appLocalStorage = new RWLocalStorage({ appPrefix });

export default appLocalStorage;
